import React from 'react';
import { ActivityIndicator, Pressable, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';
import { GoogleLogo } from '@/components/ui/google-logo';

interface SocialAuthRowProps {
  /** 'signup' só troca o verbo dos rótulos. */
  intent: 'signup' | 'login';
  /** O que o formulário acima está pedindo agora. */
  mode: 'email' | 'phone';
  /** Troca o formulário para telefone (quando `mode` é 'email'). */
  onWhatsApp: () => void;
  /** Volta o formulário para email e senha (quando `mode` é 'phone'). */
  onEmail: () => void;
  onGoogle: () => void;
  onApple: () => void;
  isGoogleLoading?: boolean;
  isAppleLoading?: boolean;
  disabled?: boolean;
}

/**
 * As outras formas de entrar, uma por linha.
 *
 * A primeira é sempre a alternativa ao que está no formulário: com email em
 * cima, oferece WhatsApp; com o telefone em cima, oferece email. É o mesmo
 * botão fazendo a volta, então não sobra nenhum "prefiro isto" solto na tela.
 */
export function SocialAuthRow({
  intent,
  mode,
  onWhatsApp,
  onEmail,
  onGoogle,
  onApple,
  isGoogleLoading,
  isAppleLoading,
  disabled,
}: SocialAuthRowProps) {
  const verb = intent === 'signup' ? 'Criar conta com' : 'Entrar com';
  const button =
    'h-11 w-full flex-row items-center justify-center gap-3 rounded-full border border-neutral-200 bg-card active:opacity-70';
  const label = 'font-semibold text-sm text-neutral-800';

  return (
    <View className="gap-2">
      {mode === 'email' ? (
        <Pressable onPress={onWhatsApp} disabled={disabled} className={button}>
          <Ionicons name="logo-whatsapp" size={18} color="#25D366" />
          <ThemedText className={label}>{verb} WhatsApp</ThemedText>
        </Pressable>
      ) : (
        <Pressable onPress={onEmail} disabled={disabled} className={button}>
          <Ionicons className="text-neutral-600" name="mail-outline" size={18} />
          <ThemedText className={label}>{verb} email</ThemedText>
        </Pressable>
      )}

      <Pressable onPress={onGoogle} disabled={disabled} className={button}>
        {isGoogleLoading ? (
          <ActivityIndicator size="small" color="#737373" />
        ) : (
          <>
            <GoogleLogo size={18} />
            <ThemedText className={label}>{verb} Google</ThemedText>
          </>
        )}
      </Pressable>

      <Pressable onPress={onApple} disabled={disabled} className={button}>
        {isAppleLoading ? (
          <ActivityIndicator size="small" color="#737373" />
        ) : (
          <>
            <Ionicons className="text-neutral-900" name="logo-apple" size={18} />
            <ThemedText className={label}>{verb} Apple</ThemedText>
          </>
        )}
      </Pressable>
    </View>
  );
}
